import type { ItemDefinition } from '../../shared/game/supply-types.js';

// Core Rules p. 36: potions take 1 action to drink or administer; two fit in one inventory slot.
export const healingPotion: ItemDefinition = {
  id: 'healing-potion', name: 'Healing Potion', description: 'A shimmering red elixir.',
  effect: { kind: 'heal', count: 2, sides: 4, bonus: 4 }, cost: 50, stack: 2,
};
export const greaterHealingPotion: ItemDefinition = {
  id: 'greater-healing-potion', name: 'Greater Healing Potion', description: 'A deep crimson draught.',
  effect: { kind: 'heal', count: 3, sides: 6, bonus: 6 }, cost: 150, stack: 2,
};
export const supremeHealingPotion: ItemDefinition = {
  id: 'supreme-healing-potion', name: 'Supreme Healing Potion', description: 'A glowing elixir prized by the wealthy.',
  effect: { kind: 'heal', count: 4, sides: 8, bonus: 8 }, cost: 450, stack: 2,
};
export const itemCatalog: ItemDefinition[] = [healingPotion, greaterHealingPotion, supremeHealingPotion];
